// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.n7JuUPCmnMmtjX {
  display: flex;
  align-items: center;
  padding: 6px 9px;
  border-radius: 3px;
  color: var(--ds-text, #172b4d);
  cursor: pointer;
}
.n7JuUPCmnMmtjX:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.bovjHJIrIWzweX {
  display: flex;
  align-items: center;
  padding: 6px 9px;
  border-radius: 3px;
  color: var(--ds-text, #172b4d);
  cursor: default;
}
.bovjHJIrIWzweX:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.vqa4H2vWLGzGUH,
.FN7fY39b4CCXpn {
  flex-shrink: 0;
  width: 32px;
  height: 28px;
  margin-right: 8px;
  border-radius: 4px;
  background-size: cover;
}
.MTsNcnyyo42EdJ {
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.GPX6jJPJl_rw7S {
  color: var(--ds-text-subtle, #44546f);
  font-style: italic;
}
.FN7fY39b4CCXpn {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
}
.FN7fY39b4CCXpn > span {
  margin: 4px 6px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardsListItem": `n7JuUPCmnMmtjX`,
	"privateBoardSummary": `bovjHJIrIWzweX`,
	"boardThumbnail": `vqa4H2vWLGzGUH`,
	"privateBoardThumbnail": `FN7fY39b4CCXpn`,
	"boardName": `MTsNcnyyo42EdJ`,
	"privateBoardTitle": `GPX6jJPJl_rw7S`
};
export default ___CSS_LOADER_EXPORT___;
